import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * LoadingSpinner — composant unifié pour les indicateurs de chargement SuiviPlus.
 *
 * 3 tailles : small (16px) / default (32px) / large (48px)
 * 3 dispositions : column (défaut, icône au-dessus du texte) / inline (côte à côte) / fullScreen (overlay)
 *
 * Exemples :
 *   Initial page : <LoadingSpinner size="large" text="Chargement..." />
 *   Inline table : <LoadingSpinner size="small" inline text="Chargement des données" />
 *   FullScreen   : <LoadingSpinner size="large" text="..." fullScreen />
 *   Sans texte   : <LoadingSpinner />
 */
const LoadingSpinner = ({
  size = "default",       // "small" | "default" | "large"
  text,                    // texte optionnel
  fullScreen = false,      // mode overlay plein écran
  inline = false,          // icône + texte sur la même ligne (au lieu de l'un sous l'autre)
  className = "",
}) => {
  const sizeClasses = {
    small: "h-4 w-4",
    default: "h-8 w-8",
    large: "h-12 w-12",
  };

  const textSizeClasses = {
    small: "text-sm",
    default: "text-base",
    large: "text-lg",
  };

  // En mode page (full), on met l'icône + texte en colonne et on centre verticalement
  // En mode inline, on aligne icône + texte horizontalement (utile dans une cellule de table, une ligne, un bouton zoné)
  const layoutClasses = inline
    ? "flex flex-row items-center justify-center gap-2"
    : "flex flex-col items-center justify-center gap-3";

  const spinner = (
    <div className={`${layoutClasses} ${className}`}>
      <Loader2 className={`${sizeClasses[size]} animate-spin text-primary`} />
      {text && (
        <p className={`${textSizeClasses[size]} text-gray-600 ${inline ? '' : 'animate-pulse'}`}>
          {text}
        </p>
      )}
    </div>
  );

  if (fullScreen) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        {spinner}
      </div>
    );
  }

  return spinner;
};

export default LoadingSpinner;
